import { render } from "./TemplateSixteen.vue?vue&type=template&id=ba38f1e0"
import script from "./TemplateSixteen.vue?vue&type=script&lang=js"
export * from "./TemplateSixteen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__